import { render, staticRenderFns } from "./DialogMessage.vue?vue&type=template&id=8a984bc8&scoped=true"
import script from "./DialogMessage.vue?vue&type=script&lang=js"
export * from "./DialogMessage.vue?vue&type=script&lang=js"
import style0 from "./DialogMessage.vue?vue&type=style&index=0&id=8a984bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a984bc8",
  null
  
)

export default component.exports